<section class="promotion-detail">
  @if (isLoading()) {
    <div class="promotion-detail__loader">
      <korviu-loader></korviu-loader>
    </div>
  } @else if (promotion()) {
    @let promo = promotion()!;
    @let state = detailState();

    <go-back class="promotion-detail__back"></go-back>

    <nav class="promotion-detail__breadcrumb" [attr.aria-label]="'promotions.detail.breadcrumbLabel' | translate">
      <a routerLink="/workspace/promotions">{{ 'promotions.title' | translate }}</a>
      <span aria-hidden="true">/</span>
      <strong>{{ promo.title }}</strong>
    </nav>

    <header class="promotion-detail__hero">
      <img
        class="promotion-detail__header-decoration"
        src="assets/img/promotions/detail/header-decoration.png"
        alt=""
        aria-hidden="true"
      />
      <img
        class="promotion-detail__ganas-badge promotion-detail__ganas-badge--ghost"
        src="assets/img/promotions/detail/ganas-badge.svg"
        alt=""
        aria-hidden="true"
      />
      <div class="promotion-detail__heading">
        <h1>{{ promo.title }}</h1>
        <div class="promotion-detail__sponsor">
          <span>{{ 'promotions.detail.sponsoredBy' | translate }}</span>
          <img [src]="promo.sponsor_avatar" alt="" aria-hidden="true" />
          <strong>{{ promo.sponsor_name }}</strong>
        </div>
      </div>
      <img
        class="promotion-detail__ganas-badge"
        src="assets/img/promotions/detail/ganas-badge.svg"
        alt=""
        aria-hidden="true"
      />
    </header>

    <div class="promotion-detail__desktop">
      <section class="promotion-detail__entry-panel">
        @if (state?.isRewardLadder) {
          <ng-container *ngTemplateOutlet="coverTemplate; context: { promo: promo }"></ng-container>
          @if (state?.cta?.visible) {
            <korviu-button
              class="promotion-detail__claim-button"
              size="large"
              [disabled]="state?.cta?.disabled ?? false"
              (click)="onCtaClick()"
            >
              <ng-container *ngTemplateOutlet="ctaContentTemplate"></ng-container>
            </korviu-button>
          }
          @if (shouldShowLadderParticipationProgress()) {
            <div class="promotion-detail__ladder-participation-progress">
              <div class="promotion-detail__progress-track">
                <span></span>
              </div>
              <strong>{{ promo.ladder_progress_label }}</strong>
            </div>
          }
        } @else {
          @if (isInstantReward()) {
            <ng-container *ngTemplateOutlet="instantRewardTemplate"></ng-container>
            @if (shouldShowInstantRewardTiles()) {
              <ng-container *ngTemplateOutlet="instantRewardTilesTemplate"></ng-container>
            }
          } @else {
            <div class="promotion-detail__prize">
              @if (!state?.isMaxEntriesUsed && !state?.isClaimState && !state?.isLost) {
                <span class="promotion-detail__tickets-bubble">
                  <strong>{{ 'promotions.detail.yourTickets' | translate }}</strong>
                  <span>{{ 'promotions.detail.availableCount' | translate: { count: availableTicketsCount() } }}</span>
                </span>
              }
              <div class="promotion-detail__prize-art">
                <img [src]="promo.prize_image" alt="" aria-hidden="true" />
              </div>
              @if (state?.cta?.visible) {
                <korviu-button
                  class="promotion-detail__apply-button"
                  size="small"
                  color="tertiary"
                  [disabled]="state?.cta?.disabled ?? false"
                  (click)="onCtaClick()"
                >
                  <ng-container *ngTemplateOutlet="ctaContentTemplate"></ng-container>
                </korviu-button>
              }
            </div>

            <div class="promotion-detail__entries" aria-hidden="true">
              @for (entry of ticketSlots; track entry) {
                <img
                  [src]="
                    entry <= filledTicketCount()
                      ? 'assets/img/promotions/detail/ticket-diagonal-filled.svg'
                      : 'assets/img/promotions/detail/ticket-diagonal.svg'
                  "
                  alt=""
                />
              }
            </div>

            @if (shouldShowStateBanner()) {
              <div class="promotion-detail__entry-summary">
                <strong>{{ 'promotions.detail.yourEntries' | translate }}</strong>
                <span>{{ entriesChanceLabel() }}</span>
              </div>
              <ng-container *ngTemplateOutlet="stateBannerTemplate"></ng-container>
            } @else {
              <p class="promotion-detail__entries-message" [innerHTML]="heroMessage()"></p>
            }
          }
        }

        @if (ctaFeedback()) {
          <button type="button" class="promotion-detail__feedback" (click)="dismissCtaFeedback()">
            {{ ctaFeedback() }}
          </button>
        }

        <div class="promotion-detail__stats promotion-detail__stats--desktop">
          <ng-container *ngTemplateOutlet="statsTemplate; context: { promo: promo }"></ng-container>
        </div>
        @if (isInstantReward() || state?.isRewardLadder) {
          <ng-container *ngTemplateOutlet="progressTemplate; context: { promo: promo }"></ng-container>
        }

        <ng-container *ngTemplateOutlet="earnTemplate"></ng-container>
      </section>

      <section class="promotion-detail__info-panel">
        @if (!state?.isRewardLadder) {
          <ng-container *ngTemplateOutlet="coverTemplate; context: { promo: promo }"></ng-container>
        }
        @if (state?.isRewardLadder) {
          <ng-container *ngTemplateOutlet="rewardLadderTemplate"></ng-container>
        }
        <ng-container *ngTemplateOutlet="tabsTemplate"></ng-container>
      </section>
    </div>

    <div class="promotion-detail__compact">
      <section class="promotion-detail__compact-prize">
        @if (!state?.isRewardLadder) {
          @if (isInstantReward()) {
            <ng-container *ngTemplateOutlet="instantRewardTemplate"></ng-container>
            @if (shouldShowInstantRewardTiles()) {
              <ng-container *ngTemplateOutlet="instantRewardTilesTemplate"></ng-container>
            }
          } @else {
            <div class="promotion-detail__prize-art">
              <img [src]="promo.prize_image" alt="" aria-hidden="true" />
            </div>
            @if (state?.cta?.visible) {
              <korviu-button
                class="promotion-detail__apply-button"
                size="small"
                color="tertiary"
                [disabled]="state?.cta?.disabled ?? false"
                (click)="onCtaClick()"
              >
                <ng-container *ngTemplateOutlet="ctaContentTemplate"></ng-container>
              </korviu-button>
            }
            <div class="promotion-detail__entries" aria-hidden="true">
              @for (entry of ticketSlots; track entry) {
                <img
                  [src]="
                    entry <= filledTicketCount()
                      ? 'assets/img/promotions/detail/ticket-diagonal-filled.svg'
                      : 'assets/img/promotions/detail/ticket-diagonal.svg'
                  "
                  alt=""
                />
              }
            </div>
            @if (shouldShowStateBanner()) {
              <div class="promotion-detail__entry-summary">
                <strong>{{ 'promotions.detail.yourEntries' | translate }}</strong>
                <span>{{ entriesChanceLabel() }}</span>
              </div>
              <ng-container *ngTemplateOutlet="stateBannerTemplate"></ng-container>
            } @else {
              <p class="promotion-detail__entries-message" [innerHTML]="heroMessage()"></p>
            }
          }
        }
      </section>

      <section class="promotion-detail__compact-cover">
        <ng-container *ngTemplateOutlet="coverTemplate; context: { promo: promo }"></ng-container>
        @if (state?.isRewardLadder) {
          <ng-container *ngTemplateOutlet="rewardLadderTemplate"></ng-container>
        }
      </section>

      <section class="promotion-detail__compact-action">
        @if (shouldShowStateBanner()) {
          <div class="promotion-detail__entry-summary">
            <strong>{{ 'promotions.detail.yourEntries' | translate }}</strong>
            <span>{{ entriesChanceLabel() }}</span>
          </div>
          <ng-container *ngTemplateOutlet="stateBannerTemplate"></ng-container>
        }
        @if (state?.cta?.visible) {
          <korviu-button size="large" [disabled]="state?.cta?.disabled ?? false" (click)="onCtaClick()">
            <ng-container *ngTemplateOutlet="ctaContentTemplate"></ng-container>
          </korviu-button>
        }
        @if (ctaFeedback()) {
          <button type="button" class="promotion-detail__feedback" (click)="dismissCtaFeedback()">
            {{ ctaFeedback() }}
          </button>
        }
        <ng-container *ngTemplateOutlet="progressTemplate; context: { promo: promo }"></ng-container>
      </section>

      <div class="promotion-detail__stats promotion-detail__stats--compact">
        <ng-container *ngTemplateOutlet="statsTemplate; context: { promo: promo }"></ng-container>
      </div>

      <div class="promotion-detail__compact-earn">
        <ng-container *ngTemplateOutlet="earnTemplate"></ng-container>
      </div>

      <section class="promotion-detail__compact-tabs">
        <ng-container *ngTemplateOutlet="tabsTemplate"></ng-container>
      </section>
    </div>
  } @else {
    <korviu-no-data size="medium" [message]="'promotions.emptyPromotions' | translate"></korviu-no-data>
  }
</section>

<ng-template #coverTemplate let-promo="promo">
  <div class="promotion-detail__cover">
    <img [src]="promo.cover_image" alt="" aria-hidden="true" />
  </div>
  @if (promo.description) {
    <p class="promotion-detail__description">{{ promo.description }}</p>
  }
</ng-template>

<ng-template #ctaContentTemplate>
  <span class="promotion-detail__cta-content">
    @if (detailState()?.cta?.iconName === 'trophy') {
      <svg
        class="promotion-detail__cta-icon"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M5.83 3.33h8.34v1.25c0 2.3-1.87 4.17-4.17 4.17S5.83 6.88 5.83 4.58V3.33Z"
          stroke="currentColor"
          stroke-width="1.4"
          stroke-linejoin="round"
        />
        <path
          d="M7.92 12.5h4.16M10 8.75v3.75M6.67 16.67h6.66M5.83 4.58H3.75c0 1.84 1.49 3.34 3.33 3.34M14.17 4.58h2.08c0 1.84-1.49 3.34-3.33 3.34"
          stroke="currentColor"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    }
    <span>{{ ctaLabel() }}</span>
  </span>
</ng-template>

<ng-template #stateBannerTemplate>
  <article
    class="promotion-detail__state-banner"
    [class.promotion-detail__state-banner--participating]="stateBannerVariant() === 'participating'"
    [class.promotion-detail__state-banner--max]="stateBannerVariant() === 'max'"
    [class.promotion-detail__state-banner--lost]="stateBannerVariant() === 'lost'"
    [class.promotion-detail__state-banner--won]="stateBannerVariant() === 'won'"
    [class.promotion-detail__state-banner--claimed]="stateBannerVariant() === 'claimed'"
  >
    <h2>{{ stateBannerTitleKey() | translate }}</h2>
    <p [innerHTML]="heroMessage()"></p>
    @if (claimRewardRows().length) {
      <div class="promotion-detail__claim-reward">
        @for (row of claimRewardRows(); track row.labelKey) {
          <dl>
            <dt>{{ row.labelKey | translate }}</dt>
            <dd>{{ row.value }}</dd>
          </dl>
        }
      </div>
    }
  </article>
</ng-template>

<ng-template #rewardLadderTemplate>
  @let primaryReward = primaryRewardRow();
  @if (primaryReward) {
    <section
      class="promotion-detail__reward-ladder"
      [attr.aria-label]="'promotions.detail.rewardTab.title' | translate"
    >
      <article class="promotion-detail__reward-ladder-main">
        <span class="promotion-detail__reward-icon promotion-detail__reward-icon--gold" aria-hidden="true">
          <ng-container
            *ngTemplateOutlet="rewardIconTemplate; context: { iconName: primaryReward.iconName }"
          ></ng-container>
        </span>
        <small>{{ primaryReward.labelKey | translate }}</small>
        <strong>{{ primaryReward.value }}</strong>
      </article>
      <div class="promotion-detail__reward-ladder-grid">
        @for (row of secondaryRewardRows(); track row.labelKey) {
          <article>
            <span
              class="promotion-detail__reward-icon"
              [class.promotion-detail__reward-icon--silver]="row.iconName === 'second-place'"
              [class.promotion-detail__reward-icon--bronze]="row.iconName === 'third-place'"
              aria-hidden="true"
            >
              <ng-container *ngTemplateOutlet="rewardIconTemplate; context: { iconName: row.iconName }"></ng-container>
            </span>
            <small>{{ row.labelKey | translate }}</small>
            <strong>{{ row.value }}</strong>
          </article>
        }
      </div>
      <article class="promotion-detail__reward-ladder-total">
        <span class="promotion-detail__reward-icon promotion-detail__reward-icon--total" aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 2.25C10.24 4.36 12.14 5.57 14.63 5.83C13.36 7.94 13.36 10.06 14.63 12.17C12.14 12.43 10.24 13.64 9 15.75C7.76 13.64 5.86 12.43 3.37 12.17C4.64 10.06 4.64 7.94 3.37 5.83C5.86 5.57 7.76 4.36 9 2.25Z"
              stroke="currentColor"
              stroke-width="1.3"
              stroke-linejoin="round"
            />
            <path
              d="M6.75 9.1L8.25 10.6L11.25 7.6"
              stroke="currentColor"
              stroke-width="1.3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <strong>{{ 'promotions.detail.rewardTab.moreThanPrizes' | translate }}</strong>
        <button type="button" (click)="onViewAllPrizesClick()">
          {{ 'promotions.detail.rewardTab.viewAllPrizes' | translate }}
        </button>
      </article>
    </section>
  }
</ng-template>

<ng-template #instantRewardTemplate>
  <section
    class="promotion-detail__instant-reward"
    [attr.aria-label]="'promotions.detail.instantReward.title' | translate"
  >
    <div class="promotion-detail__instant-ticket">
      <span class="promotion-detail__instant-tickets-bubble">
        <strong>{{ 'promotions.detail.yourTickets' | translate }}</strong>
        <span>{{ 'promotions.detail.availableCount' | translate: { count: availableTicketsCount() } }}</span>
      </span>
      <div class="promotion-detail__instant-copy">
        <strong>{{ 'promotions.detail.instantReward.title' | translate }}</strong>
        <span>{{ 'promotions.detail.instantReward.description' | translate }}</span>
      </div>
      <button type="button" [disabled]="shouldShowInstantRewardTiles()" (click)="onInstantRewardTap()">
        {{
          shouldShowInstantRewardTiles()
            ? ('promotions.detail.instantReward.youWon' | translate)
            : ('promotions.detail.instantReward.tapHere' | translate)
        }}
      </button>
    </div>
  </section>
</ng-template>

<ng-template #instantRewardTilesTemplate>
  <div class="promotion-detail__instant-tiles">
    @for (tile of instantRewardTiles(); track tile.id) {
      <article>
        <span>{{ tile.labelKey | translate }}</span>
        <strong>{{ tile.value }}</strong>
      </article>
    }
  </div>
</ng-template>

<ng-template #rewardIconTemplate let-iconName="iconName">
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.25 2.5h5.5v3.25c0 1.52-1.23 2.75-2.75 2.75S5.25 7.27 5.25 5.75V2.5Z"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linejoin="round"
    />
    <path d="M6.5 8.25v4.25L8 11.75l1.5.75V8.25" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round" />
    @if (iconName === 'second-place') {
      <text x="8" y="6.45" text-anchor="middle">2</text>
    }
    @if (iconName === 'third-place') {
      <text x="8" y="6.45" text-anchor="middle">3</text>
    }
  </svg>
</ng-template>

<ng-template #statsTemplate let-promo="promo">
  @if (!isInstantReward() && !detailState()?.isRewardLadder) {
    <article class="promotion-detail__stat promotion-detail__stat--cost">
      <span>{{ 'promotions.detail.cost' | translate }}</span>
      <strong>{{ costLabel() }}</strong>
    </article>
  }
  <article class="promotion-detail__stat">
    <span>{{ 'promotions.detail.status' | translate }}</span>
    <strong class="promotion-detail__tag">{{ statusLabel() }}</strong>
  </article>
  <article class="promotion-detail__stat">
    <span>{{ 'promotions.detail.endDate' | translate }}</span>
    <strong>{{ endDateLabel() }}</strong>
  </article>
  @if (isInstantReward() || detailState()?.isRewardLadder) {
    <article class="promotion-detail__stat promotion-detail__stat--cost">
      <span>{{ 'promotions.detail.cost' | translate }}</span>
      <strong>{{ costLabel() }}</strong>
    </article>
  }
</ng-template>

<ng-template #progressTemplate let-promo="promo">
  <div class="promotion-detail__progress">
    <div class="promotion-detail__progress-track">
      <span [style.width.%]="progressPercent()"></span>
    </div>
    <div class="promotion-detail__progress-labels">
      <strong>0</strong>
      <span>{{ progressLabel() }}</span>
      <strong>{{ promo.rewards_total }}</strong>
    </div>
  </div>
</ng-template>

<ng-template #earnTemplate>
  <a routerLink="/workspace/promotions/missions" class="promotion-detail__earn">
    <span>
      <strong>{{ 'promotions.detail.earnMoreTickets' | translate }}</strong>
      <small>{{ 'promotions.detail.increaseChances' | translate }}</small>
    </span>
    <i aria-hidden="true">
      <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="28" cy="28" r="28" fill="#FFC34D" />
        <path d="M18 23h20v18H18V23Z" fill="#27A7D8" />
        <path d="M16 21h24v7H16v-7Z" fill="#E9F6F5" />
        <path d="M27 17h4v24h-4V17Z" fill="#0F8A7C" />
        <path d="M20 18c5-6 8 1 8 3-5 0-8-.5-8-3Z" fill="#0F8A7C" />
        <path d="M36 18c-5-6-8 1-8 3 5 0 8-.5 8-3Z" fill="#0F8A7C" />
      </svg>
    </i>
    <svg class="promotion-detail__earn-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M6 3.5L10.5 8L6 12.5" stroke="#505760" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </a>
</ng-template>

<ng-template #tabsTemplate>
  <div class="promotion-detail__tabs" role="tablist" [attr.aria-label]="'promotions.detail.tabsLabel' | translate">
    @for (tab of tabs; track tab.id) {
      <button
        type="button"
        role="tab"
        [attr.aria-selected]="selectedTab() === tab.id"
        [class.promotion-detail__tab--active]="selectedTab() === tab.id"
        (click)="onTabClick(tab.id)"
      >
        {{ tab.labelKey | translate }}
      </button>
    }
  </div>

  <section class="promotion-detail__table" [class.promotion-detail__table--empty]="!tabRows().length">
    <h2>{{ tabContentTitleKey() | translate }}</h2>
    @if (activeTabContentType() === 'details') {
      <strong>{{ 'promotions.detail.id' | translate: { id: promotion()?.id } }}</strong>
    }
    @for (row of tabRows(); track row.labelKey) {
      <dl>
        <dt>{{ row.labelKey | translate }}</dt>
        <dd>{{ row.value }}</dd>
      </dl>
    } @empty {
      <p>{{ 'promotions.detail.noTabContent' | translate }}</p>
    }
    @if (promotion()?.claim_tax_info && detailState()?.isClaimState) {
      <p class="promotion-detail__notice">{{ promotion()?.claim_tax_info | translate }}</p>
    }
    @if (promotion()?.claim_info && detailState()?.isClaimState) {
      <p class="promotion-detail__notice">{{ promotion()?.claim_info | translate }}</p>
    }
  </section>
  @if (shouldShowWinnersBlock()) {
    <section class="promotion-detail__winners-block">
      <div class="promotion-detail__winners-header">
        <h2>{{ 'promotions.detail.winnersModal.title' | translate }}</h2>
        <button type="button" (click)="openWinnersModal()">
          {{ 'promotions.viewAll' | translate }}
        </button>
      </div>
      <div class="promotion-detail__winners-list">
        @for (winner of topWinnerRows(); track winner.id) {
          <article>
            <span>{{ winner.place }}</span>
            <strong>{{ winner.name }}</strong>
            <small>{{ winner.reward }}</small>
          </article>
        }
      </div>
    </section>
  }
</ng-template>
